import HttpClient from 'core/util/httpClient/application/HttpClient';
import { endPoints } from 'core/util/httpClient/domain/constants/endpoints';
import type INotificationRepository from '../domain/repository/notification.repository';
import { desN } from "core/admissions/infrastructure/desN/desN";

class NotificationProvider implements INotificationRepository {
  protected readonly httpAdapter;

  constructor() {
    this.httpAdapter = HttpClient.getInstance().getHttpAdapter();
  }

  async getNotification(data: any) {
    const res = await this.httpAdapter.get(endPoints.notification.get(data), data);

    const decrypted = await desN(res.data);

    return {
      ...res,
      data: decrypted
    };
  }

  async deleteNotification(id: string) {
    return await this.httpAdapter.delete(endPoints.notification.delete(id));
  }

  async markAsRead(id: any) {
    return await this.httpAdapter.post(endPoints.notification.read, { id });
  }
}

export default NotificationProvider;
